span(data-test='identity') {{ bidderIdentity }}
